import { Descriptions } from "@/components/v2";
import { type DescriptionsProps, Popconfirm, Space } from "antd";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { useCompleteTaskMutation } from "../lib/hooks/useCompleteTaskMutation";
import { CheckOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { TaskPriority } from "./TaskPriority";
import { Button, Card } from "@rumbledirect/ui";

interface TaskDetailCardProps {
  task: Task | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const TaskDetailCard = ({
  task,
  isLoading,
  deleteMutation,
}: TaskDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Taak",
      children: task?.description ?? null,
    },
    {
      label: "Extra notitie taak",
      children: task?.note ?? null,
    },
    {
      label: "Prioriteit",
      children: <TaskPriority priority={task?.priority} />,
    },
    {
      label: "Status",
      children: task?.status ?? null,
    },
    {
      label: "Toegewezen aan",
      children: task?.assignee
        ? `${task.assignee.firstName} ${task.assignee.lastName}`
        : null,
    },
    {
      label: "Gemaakt door",
      children: task?.reporter
        ? `${task.reporter.firstName} ${task.reporter.lastName}`
        : null,
    },
  ];

  const completeMutation = useCompleteTaskMutation();

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Taak"
      extra={
        <Space>
          {task?.isCompleted == false && (
            <Popconfirm
              title="Taak afvinken"
              description="Weet je zeker dat je deze taak wilt afvinken?"
              okText="Ja"
              cancelText="Nee"
              onConfirm={() => completeMutation.mutate(task.id)}
            >
              <Button color="green" icon={<CheckOutlined />}>
                Afvinken
              </Button>
            </Popconfirm>
          )}
          <Button
            href={`/claims/tasks/${task?.id}/edit`}
            icon={<EditOutlined />}
          >
            Bewerken
          </Button>
          <Popconfirm
            title="Taak verwijderen"
            description="Weet je zeker dat je deze taak wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              danger
              loading={deleteMutation?.isPending}
              icon={<DeleteOutlined />}
            >
              Verwijderen
            </Button>
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
